const resource = '/admin/v1/applications/modals'

export default $axios => ({
  createOrUpdate(payload) {
    return $axios.post(`${resource}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  }
})
